<template lang="pug">
  paginate(
    :pageCount="pageCount"
    :pageRange="pageRange"
    :clickHandler="clickHandler"
    :prevText="gettext('Prev')"
    :nextText="gettext('Next')"
    :containerClass="'pagination'"
    :forcePage="initialPage"
    :initialPage="initialPage"
  )
</template>

<script>
import { mapGetters } from 'vuex'
import { gettext } from '@/services/TranslateHandler'
import Paginate from 'vuejs-paginate'

export default {
  name: 'VuePaginate',
  props: {
    pageCount: {
      default: 0
    },
    pageRange: {
      default: 5
    },
    clickHandler: {
      default: () => {
        return void (0)
      }
    },
    initialPage: {
      default: 0
    }
  },
  components: {
    Paginate
  },
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ])
  },
  created () {
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 769) {
        this.pagPerPage = 4
      }
      if (window.innerWidth <= 768) {
        this.pagPerPage = 2
      }
    })

    if (window.innerWidth <= 768) {
      this.pagPerPage = 2
    }
  }
}
</script>

<style lang='scss' scoped>

</style>



// WEBPACK FOOTER //
// src/components/paginate/index.vue